/**
 * Un trozo legible de un párrafo alrededor de un nombre: desde el principio de su frase si está a menos de medio ancho, si no
 * desde el principio de una palabra, y cortado en una palabra. Es la misma regla que nexo.ventana_texto (dossier de Argus Team,
 * migración 20261002120000), para que Nexo y Argus Team muestren el mismo pasaje del comunicado.
 */
export function ventanaTexto(texto: string | null, aguja: string | null, ancho = 700): string | null {
  if (!texto) return null;
  // Fuera los caracteres invisibles que trae el HTML de Treasury (espacios de ancho cero, marcas de dirección).
  const t = texto.replace(/[\u200B-\u200F\uFEFF]/g, "");
  if (t.length <= ancho) return t.trim();
  const p = Math.max(0, aguja ? t.toLowerCase().indexOf(aguja.toLowerCase()) : 0);
  let a = Math.max(0, p - Math.floor(ancho / 2));
  if (a > 0) {
    const frase = t.lastIndexOf(". ", p - 1);
    a = frase >= a ? frase + 2 : t.indexOf(" ", a) + 1;
  }
  let r = t.slice(a, a + ancho);
  if (a + ancho < t.length) r = r.replace(/\s+\S*$/, "") + "…";
  return (a > 0 ? "…" : "") + r.trim();
}
